// inject styles
import './scss/app.scss';

// load spyne
import { SpyneApp, ChannelFetch, SpyneAppProperties } from 'spyne';

// channels
import { ChannelMenuDrawer } from 'channels/channel-menu-drawer';
import { ChannelAppStatus } from 'channels/channel-app-status.js';
import { ChannelCodeblock } from 'channels/_design-systems/channel-codeblock.js';
import { ChannelLocalStorage } from 'channels/channel-local-storage.js';
//plugins

import { SpyneCmsPlugin } from "@spynejs/cms";

//data fetch
import AppContentData from 'data/design-spynejs-data.json';

// initial view
import { AppView } from './app/app-view.js';

import * as R from 'ramda';
import pageItemTemplateLookup from 'traits/utils/page-item-template-lookup.js';


window.R = R;


console.log("IMG PATH IS ",IMG_PATH);
const config = {
  debug: true,
  storageConfig: {
    storageKey: 'spyneAppStorage',
    analyticsOptions: {
      provider: 'plausible',
      endpoint: '/api/analytics',
      sendIntervalMs: 30000,
    },
    theme: 'auto',
    themeDefaults: {
      colorScheme: 'auto',
      enableTransitions: true,
    },
    cms: {
      enabled: true,
      autoSync: false,
    },
  },

  channels: {
    WINDOW: {
      mediaQueries: {
        showMenuDrawer: `(min-width: 1024px)`,
      },
      events: ['click', 'mouseover', 'message', 'keyup'],

      listenForScroll: true,
      listenForOrientation: true,
      debounceMSTimeForScroll: 50,
    },

    ROUTE: {
      add404s: false,
      routes: {
        routePath: {
          routeName: 'pageId',
          home: '',
          'page-landing': 'page-landing',
          'page-about': 'page-about',
          'page-view': {
            routePath: {
              routeName: 'topicId',
            },
          },

          sections: {
            routePath: {
              routeName: 'topicId',
              hero: 'hero',
              features: 'features',
              testimonials: 'testimonials',
              pricing: 'pricing',
              faq: 'faq',
              footer: 'footer',
            },
          },
          containers: {
            routePath: {
              routeName: 'topicId',
              /*              "header": "header",
              "main": "main",
              "form-container": "form-container",*/
              sidebar: 'sidebar',
              'card-grid': 'card-grid',
            },
          },
          components: {
            routePath: {
              routeName: 'topicId',
              card: 'card',
              accordion: 'accordion',
              modal: 'modal',
              tabs: 'tabs',
              toast: 'toast',
              pagination: 'pagination',
            },
          },
          elements: {
            routePath: {
              routeName: 'topicId',
              typography: 'typography',
              buttons: 'buttons',
              links: 'links',
              forms: {
                forms: 'forms',
                routePath: {
                  routeName: 'optionId',
                  input: 'input',
                  textarea: 'textarea',
                  checkbox: 'checkbox',
                  radio: 'radio',
                  select: 'select',
                },
              },
              lists: 'lists',
              tables: 'tables',
            },
          },
          utilities: 'utilities',
          /*          "utilities": {
            "routePath": {
              "routeName": "topicId",
              "spacing": "spacing",
              "flex-grid": "flex-grid",
              "typography-utils": "typography-utils",
              "theme-utils": "theme-utils"
            }
          }*/
        },
      },
    },
  },
};

SpyneApp.init(config);


SpyneAppProperties.setProp('pageItemTemplateLookup', pageItemTemplateLookup);
SpyneApp.registerChannel(new ChannelCodeblock());
SpyneApp.registerChannel(new ChannelAppStatus());
SpyneApp.registerChannel(new ChannelLocalStorage());
SpyneApp.registerChannel(new ChannelMenuDrawer());
let dataMapper = (d)=>d;




const cmsPluginConfig1 = {
  position: ["bottom", "right"],
  openOnLoad: true,
  darkMode: true,
  minimize: true,
};

const cmsPluginConfig = {
  position: ['bottom', 'right'],
  openOnLoad: true,
  darkMode: true,
  maximize: true

}

if (process.env.NODE_ENV === "development") {



  const spyneCmsPlugin = new SpyneCmsPlugin(cmsPluginConfig);

  SpyneApp.registerPlugin(spyneCmsPlugin);
  dataMapper = SpyneApp.pluginsFn.mapCmsData;
}






SpyneApp.registerChannel(
  new ChannelFetch('CHANNEL_APP_DATA', {
    url: AppContentData,
    map: dataMapper
  }),
);

if (process.env.NODE_ENV === 'development') {
  import('./dev-tools.js');
}



new AppView().prependToDom(document.querySelector('body'));

